import { Time } from '@angular/common';
import { MerchantDto, MerchantMenuDto } from '@up/data';
import { timeToDate } from '../extensions/date.helper';

//For requests using DTO Objects
export function findMenuByTimeDTOFormat(
  menus: MerchantMenuDto[],
  merchant: MerchantDto,
  weekDayNow: number,
  timeNow: number,
  isOrderAtTable?: boolean,
  isUltraOrder?: boolean,
): MerchantMenuDto {
  const currentDate = new Date();

  const filterOrderingMenu = (
    menu: MerchantMenuDto,
    isOrderAtTable: boolean
  ): boolean => {
    if (isOrderAtTable) {
      return menu.isOrderAtTable;
    }
    if (isUltraOrder) {
      return menu.isUltraOrder;
    }
    return menu.isWebOrdering || menu.isCatering;
  };


  let menusWithValidMenuHourOverNight = [];

  menusWithValidMenuHourOverNight = menus?.filter((menu) => {
    const validMenuHour = menu.menuHours?.find(
      (menuHour) =>
        menuHour.isAvailable &&
        menuHour.isOverNight &&
        //check for the previous weekday, monday not checked
        ((weekDayNow !== 0 && weekDayNow - 1 === menuHour.weekday) ||
          //check for the monday weekday and menuHour for sunday weekday
          (weekDayNow === 0 && menuHour.weekday === 6))
    );

    let isValidEndTime = false;

    if (
      validMenuHour &&
      filterOrderingMenu(menu, isOrderAtTable) &&
      new Date(menu.startDate) < currentDate &&
      (!menu.endDate || new Date(menu.endDate) > currentDate)
    ) {
      const endTime = timeToDate(validMenuHour.endTime, true);

      if (endTime > currentDate) isValidEndTime = true;
    }

    let mondayOrTodayMenuHour;

    if (!isValidEndTime) {
      mondayOrTodayMenuHour = menu.menuHours?.find(
        (menuHour) =>
          menuHour.isAvailable &&
          menuHour.isOverNight === true &&
          //check for the monday weekday with menuHour
          ((weekDayNow === 0 && menuHour.weekday === 0) ||
            //check for the current day
            weekDayNow === menuHour.weekday)
      );

      if (mondayOrTodayMenuHour) {
        const mondayEndTime = timeToDate(mondayOrTodayMenuHour.endTime, true);
        mondayEndTime.setUTCDate(mondayEndTime.getUTCDate() + 1);

        if (mondayEndTime > currentDate) isValidEndTime = true;
      }
    }
    
    return isValidEndTime
      ? mondayOrTodayMenuHour
        ? mondayOrTodayMenuHour && filterOrderingMenu(menu, isOrderAtTable)
        : validMenuHour && filterOrderingMenu(menu, isOrderAtTable)
      : null;
  });

  // order by startTime to the find (find first the earlier one) and in case doesnt found get the earlier one
  menusWithValidMenuHourOverNight?.sort((a, b) => {
    return transformTimetoInt(
      a.menuHours?.find((e) => e.weekday === weekDayNow).startTime,
      true
    ) >
      transformTimetoInt(
        b.menuHours?.find((e) => e.weekday === weekDayNow).startTime,
        true
      )
      ? 1
      : -1;
  });

  // Return the earlier over night menu or return null if no menu was found
  const menuWithOverNightSelected = menusWithValidMenuHourOverNight?.length
    ? menusWithValidMenuHourOverNight[0]
    : null;

  // needs to get ride of all past the end time but save the start and then select the one that is inside and earlier if not the nearst one
  const menusFiltered = menus
    ?.filter(
      (menu) =>
        menu.menuHours?.filter(
          (menuHour) =>
            menuHour.isAvailable &&
            !menuHour.isOverNight &&
            menuHour.weekday === weekDayNow &&
            transformTimetoInt(menuHour.endTime, true) > timeNow
        )?.length > 0 &&
        filterOrderingMenu(menu, isOrderAtTable) &&
        new Date(menu.startDate) < currentDate &&
        (!menu.endDate || new Date(menu.endDate) > currentDate)
      // order by startTime to the find (find first the earlier one) and in case doesnt found get the earlier one
    )
    .sort((a, b) => {
      return transformTimetoInt(
        a.menuHours?.find((e) => e.weekday === weekDayNow).startTime,
        true
      ) >
        transformTimetoInt(
          b.menuHours?.find((e) => e.weekday === weekDayNow).startTime,
          true
        )
        ? 1
        : -1;
    });
  let menuSelected = menusFiltered?.find(
    (menu) =>
      transformTimetoInt(
        menu.menuHours?.find((e) => e.weekday === weekDayNow).startTime,
        true
      ) < timeNow
  );
  // if doesnt found any active menu, we choose the earlier one but if there is not earlier return null
  if (!menuSelected) {
    menuSelected = menusFiltered?.length ? menusFiltered[0] : null;
  }
  return menuWithOverNightSelected ? menuWithOverNightSelected : menuSelected;
}

function transformTimetoInt(menuHours: Time, transformTime?: boolean): number {
  // transform the time from utc to local gmt
  const date = timeToDate(menuHours, true);
  // even is more acurate *60 is easier to review the value and display with 100 and wont impact too much
  return transformTime
    ? date.getHours() * 100 + date.getMinutes()
    : Number(menuHours.hours) * 100 + Number(menuHours.minutes);
}
